import { Button, ButtonProps, Row, RowProps, SvgIconProps } from "@commonlibs";
import clsx from "clsx";
import { JSXElementConstructor } from "react";
import { spacing } from "ui/config/theme/spacing/spacing";

export type ButtonWithIconProps = Omit<ButtonProps, "children"> & {
    label: string;
    /**
     * Icon component from the icons folder: "ui/common/icons";
     */
    Icon: JSXElementConstructor<Omit<SvgIconProps, "children">>;
    gap?: RowProps["gap"];
};

const ButtonWithIcon = ({ className, Icon, label, gap, variant = "outlined", ...rest }: ButtonWithIconProps) => {
    return (
        <Button className={clsx("button-with-icon", className)} variant={variant} {...rest}>
            <Row flex={1} alignItems="center" justifyContent="center" gap={gap || spacing["1"]}>
                <Icon className="button-with-icon-icon" />
                <span className="button-with-icon-label">{label}</span>
            </Row>
        </Button>
    );
};

export default ButtonWithIcon;
